import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";
import {Exchange} from "app/instruments/exchange/Exchange";
import {
    Dividend,
    Dividends,
    orderDividendsByDateAsc,
    orderDividendsByDateDesc
} from "app/dividends/types/DividendsRecord";
import {IsoDate} from "app/pseudo-types/DateTypes";
import {Predicate} from "../../types/GenericTypes";

export class DividendsModel implements CodeAndExchange {

    public readonly dividends: Dividends;

    private constructor(public readonly asAt: IsoDate,
                        public readonly code: string,
                        public readonly exchange: Exchange,
                        dividends: Dividends) {
        this.dividends = [...dividends].sort(orderDividendsByDateDesc());
    }

    public isEmpty(): boolean {
        return this.dividends.length === 0;
    }

    public next(): Dividend | null {
        return this.dividends.filter((d) => d.exDate >= this.asAt).sort(orderDividendsByDateAsc())[0];
    }

    public last(): Dividend | null {
        return this.dividends[0];
    }

    public filter(predicate: Predicate<Dividend>): DividendsModel {
        const dividends = this.dividends.filter(predicate);
        return new DividendsModel(this.asAt, this.code, this.exchange, dividends);
    }

    public static of(asAt: IsoDate, code: string, exchange: Exchange, dividends: Dividends): DividendsModel {
        return new DividendsModel(asAt, code, exchange, dividends);
    }
}
